<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import ScientificCalc from './components/ScientificCalc.vue';
import { useDocumentMeta } from './composables/useDocumentMeta';

const { t } = useI18n();
useDocumentMeta();

const isDevDeploy = import.meta.env.VITE_DEPLOY_ENV === 'development';
</script>

<template>
  <div class="win-app" role="application" :aria-label="t('appTitle')">
    <span v-if="isDevDeploy" class="env-badge" aria-hidden="true">DEV</span>
    <header class="win-header" aria-hidden="true">
      <div class="window-chrome">
        <span class="chrome-btn" />
        <span class="chrome-btn" />
        <span class="chrome-btn close" />
      </div>
    </header>
    <main class="win-body">
      <ScientificCalc />
    </main>
  </div>
</template>

<style scoped>
.win-app {
  position: relative;
  width: var(--win-shell-w);
  height: var(--win-shell-h);
  display: flex;
  flex-direction: column;
  background: var(--win-glass);
  backdrop-filter: blur(24px) saturate(1.2);
  -webkit-backdrop-filter: blur(24px) saturate(1.2);
  border-radius: var(--win-radius-window);
  box-shadow: var(--win-shadow-window);
  border: 1px solid var(--win-border);
  overflow: hidden;
  flex-shrink: 0;
}

.win-header {
  display: flex;
  justify-content: flex-end;
  height: 32px;
  flex-shrink: 0;
}

.window-chrome {
  display: flex;
}

.chrome-btn {
  width: 40px;
  height: 32px;
  display: inline-block;
}

.chrome-btn:hover {
  background: var(--win-key-num-hover);
}

.chrome-btn.close:hover {
  background: #c42b1c;
}

.win-body {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.env-badge {
  position: absolute;
  top: 36px;
  left: 8px;
  z-index: 2;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.05em;
  padding: 2px 6px;
  border-radius: 4px;
  background: #c42b1c;
  color: #fff;
  pointer-events: none;
}
</style>
